const keyAccessToken = "access_token"
const keyRefreshToken = "refresh_token"

const INITIAL_STATE = {
    access_token: localStorage.getItem(keyAccessToken),
}

const authReduceFuncao = (state = INITIAL_STATE, action) => {
    // export default  (state = INITIAL_STATE, action) => {
    //   alert("teste03: " + action.type )
    switch (action.type) {
        case "USER_LOGIN":

            localStorage.setItem(keyAccessToken, action.payload.token)
            localStorage.setItem(keyRefreshToken, action.payload.refreshToken)

            //           let quantSegundosAteATokenExpirar = 1000
            let quantSegundosAteATokenExpirar = 1000
            // alert("name: " + action.payload.user.usulogin)
            setTimeout(() => {
                //REFRESH-TOKEN
            }, quantSegundosAteATokenExpirar)

            ///action.payload. ... sao campos devolvidos pelo backend
            ///neste caso foi la no rotina "auth"
            /// trouxe dos campos em um vetor e soltos tambem como o token
            return {
                ...state, access_token: action.payload.token
                , NomUsuario: action.payload.user.usulogin
                , CodUsuario: action.payload.user.usuid
                , CodPuxada: action.payload.user.cod_puxada
                , TipoUsuario: action.payload.user.tipo_Usu
                // , Errologin: "0"
            }
        // case "USER_ERRO_LOGIN":
        //     console.log("action.payload " + action.payload)
        //     return { ...state, Errologin: action.payload }

        case "USER_LOGOUT":
            if (!action.payload) {
                localStorage.removeItem(keyAccessToken)
                localStorage.removeItem(keyRefreshToken)
                return { ...state, access_token: null }
            }
            else {
                return state
            }

        case "SHOW_USU":
            return { ...state, UsuarioLogin: action.payload }

        case "AUTOPMSACS":
            //            alert("1:" + action.payload)
            return { ...state, LstdeAcessoUsu: action.payload };

        case "VersaoBackEndxx":
            return { ...state, VersaoBackEndcc: action.payload };

        // dá para colocar mas tem que fazer a chamada no autactions
        // para poder carregar e depois usar
        // tipo: chama VersaoBackEndxx e depois chama EnderecoHTTPS
        // para carregar e depois e pega novamente 
        // case "EnderecoHTTPS"    :
        //     return {...state, BaseURL_Auth: "https://localhost:44308/api"}

        case "ENVIA_EMAIL":
            return { ...state, RepostaEnvioEmail: action.payload };
        case "GET_DATA_ACESSOS_DOEMAIL":
            return { ...state, vetorCmpEmailAcs: action.payload };
        case "GET_CAMPOS_ACSUSU":
            return { ...state, vetorCmpAcsUsu: action.payload.data }

        default:
            return state
    }

}
export default authReduceFuncao;
